/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppRouteImport } from './routes/app'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppDictionaryRouteImport } from './routes/app.dictionary'
import { Route as AppDashboardRouteImport } from './routes/app.dashboard'
import { Route as AppCanvasRouteImport } from './routes/app.canvas'
import { Route as AppSettingsProtheusRouteImport } from './routes/app.settings.protheus'
import { Route as AppDictionaryAliasRouteImport } from './routes/app.dictionary.$alias'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppDictionaryRoute = AppDictionaryRouteImport.update({
  id: '/dictionary',
  path: '/dictionary',
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardRoute = AppDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRoute,
} as any)
const AppCanvasRoute = AppCanvasRouteImport.update({
  id: '/canvas',
  path: '/canvas',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsProtheusRoute = AppSettingsProtheusRouteImport.update({
  id: '/settings/protheus',
  path: '/settings/protheus',
  getParentRoute: () => AppRoute,
} as any)
const AppDictionaryAliasRoute = AppDictionaryAliasRouteImport.update({
  id: '/$alias',
  path: '/$alias',
  getParentRoute: () => AppDictionaryRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/app/canvas': typeof AppCanvasRoute
  '/app/dashboard': typeof AppDashboardRoute
  '/app/dictionary': typeof AppDictionaryRouteWithChildren
  '/app/dictionary/$alias': typeof AppDictionaryAliasRoute
  '/app/settings/protheus': typeof AppSettingsProtheusRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/app/canvas': typeof AppCanvasRoute
  '/app/dashboard': typeof AppDashboardRoute
  '/app/dictionary': typeof AppDictionaryRouteWithChildren
  '/app/dictionary/$alias': typeof AppDictionaryAliasRoute
  '/app/settings/protheus': typeof AppSettingsProtheusRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/app/canvas': typeof AppCanvasRoute
  '/app/dashboard': typeof AppDashboardRoute
  '/app/dictionary': typeof AppDictionaryRouteWithChildren
  '/app/dictionary/$alias': typeof AppDictionaryAliasRoute
  '/app/settings/protheus': typeof AppSettingsProtheusRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/app'
    | '/login'
    | '/app/canvas'
    | '/app/dashboard'
    | '/app/dictionary'
    | '/app/dictionary/$alias'
    | '/app/settings/protheus'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/app'
    | '/login'
    | '/app/canvas'
    | '/app/dashboard'
    | '/app/dictionary'
    | '/app/dictionary/$alias'
    | '/app/settings/protheus'
  id:
    | '__root__'
    | '/'
    | '/app'
    | '/login'
    | '/app/canvas'
    | '/app/dashboard'
    | '/app/dictionary'
    | '/app/dictionary/$alias'
    | '/app/settings/protheus'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/dictionary': {
      id: '/app/dictionary'
      path: '/dictionary'
      fullPath: '/app/dictionary'
      preLoaderRoute: typeof AppDictionaryRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/dashboard': {
      id: '/app/dashboard'
      path: '/dashboard'
      fullPath: '/app/dashboard'
      preLoaderRoute: typeof AppDashboardRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/canvas': {
      id: '/app/canvas'
      path: '/canvas'
      fullPath: '/app/canvas'
      preLoaderRoute: typeof AppCanvasRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/settings/protheus': {
      id: '/app/settings/protheus'
      path: '/settings/protheus'
      fullPath: '/app/settings/protheus'
      preLoaderRoute: typeof AppSettingsProtheusRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/dictionary/$alias': {
      id: '/app/dictionary/$alias'
      path: '/$alias'
      fullPath: '/app/dictionary/$alias'
      preLoaderRoute: typeof AppDictionaryAliasRouteImport
      parentRoute: typeof AppDictionaryRoute
    }
  }
}

interface AppDictionaryRouteChildren {
  AppDictionaryAliasRoute: typeof AppDictionaryAliasRoute
}

const AppDictionaryRouteChildren: AppDictionaryRouteChildren = {
  AppDictionaryAliasRoute: AppDictionaryAliasRoute,
}

const AppDictionaryRouteWithChildren = AppDictionaryRoute._addFileChildren(
  AppDictionaryRouteChildren,
)

interface AppRouteChildren {
  AppCanvasRoute: typeof AppCanvasRoute
  AppDashboardRoute: typeof AppDashboardRoute
  AppDictionaryRoute: typeof AppDictionaryRouteWithChildren
  AppSettingsProtheusRoute: typeof AppSettingsProtheusRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppCanvasRoute: AppCanvasRoute,
  AppDashboardRoute: AppDashboardRoute,
  AppDictionaryRoute: AppDictionaryRouteWithChildren,
  AppSettingsProtheusRoute: AppSettingsProtheusRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
